import React from "react";

interface TooltipIconProps extends React.HTMLAttributes<HTMLDivElement> {
  src: string;
  alt: string;
  width: number;
  height: number;
}

const TooltipIcon = React.forwardRef<HTMLDivElement, TooltipIconProps>(
  ({ src, alt, width, height, ...props }, ref) => {
    return (
      <div ref={ref} {...props}>
        <img src={src} alt={alt} width={width} height={height} />
      </div>
    );
  }
);

TooltipIcon.displayName = "TooltipIcon";
export default TooltipIcon;